import { Button, Layout, notification } from "antd";

export default function PageScoreCardFormThankYou() {
	return (
		<Layout.Content>
			<div className="main-content">
				<div className="logo-wrapper">
					<img
						src="/assets/joyalifevertical_green_on_white_transparent.png"
						alt="joyalifevertical_green_on_white_transparent.png"
					/>
				</div>

				<div className="content-title">THANK YOU!</div>

				<div className="content-description text-center">
					<div>
						Think a partner, colleague, or friend could benefit from the Joya
						Life Scorecard?
					</div>
					<br />
					<Button
						type="link"
						onClick={() => {
							// copy to clipboard
							navigator.clipboard.writeText(window.location.origin);
							notification.success({
								message: "Link copied to clipboard",
								description: "You can now share the link with others.",
							});
						}}
					>
						Click here to share this link
					</Button>
				</div>
			</div>

			<div className="footer">
				<div>
					<i>Disclaimer:</i>
				</div>
				<br />
				<div>
					<i>
						Nothing in the scorecard is meant to harm, nor provide a specific
						diagnosis or advice at this stage. If you need help, please speak to
						your GP or appropriate expert to get a referral to a qualified
						professional.
					</i>
				</div>
				<br />
				<div className="emergency">
					If you require urgent assistance, please contact lifeline on 13 11 14
					within Australia, or look up your local equivalent outside of
					Australia.
				</div>
			</div>
		</Layout.Content>
	);
}
